import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

import { useFormatMessage } from "../../../intl/intlHooks";
import { loginUrl } from "../../../user/utils";
import { toQueryString } from "../../../utils/sharedFunctions";
import { orderSummarySSOCheckout } from "../orderSummaryMessages";


export const getLoginTextValues = name => ({
    name,
    
    b: (...chunks) => <b>{chunks}</b>
});

const SSOLoggedIn = ({ children, firstName }) => {
    const formatMessage = useFormatMessage();
    const location = useLocation();
    const initUrl = `${loginUrl}${toQueryString({ redirect_url: location.pathname })}`;
    return (
        <Fragment>
            <div className="logged-in">
                <span className="logged-in-text">
                    {formatMessage(orderSummarySSOCheckout.loggedInText, getLoginTextValues(firstName))}
                    &nbsp;
                    <a href={initUrl}>
                        {formatMessage(orderSummarySSOCheckout.logInText)}
                    </a>
                </span>
            </div>
            {children}
        </Fragment>
    );
};

SSOLoggedIn.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    firstName: PropTypes.string.isRequired
};

export default SSOLoggedIn;
